import { render } from "./PriceTicker.vue?vue&type=template&id=1f98674a&scoped=true"
import script from "./PriceTicker.vue?vue&type=script&lang=js"
export * from "./PriceTicker.vue?vue&type=script&lang=js"

import "./PriceTicker.vue?vue&type=style&index=0&id=1f98674a&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f98674a"]])

export default __exports__